import { dew as _errorsDew } from "../errors";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var errors_1 = _errorsDew();

  var PDFObject =
  /** @class */
  function () {
    function PDFObject() {}

    PDFObject.prototype.clone = function (_context) {
      throw new errors_1.MethodNotImplementedError(this.constructor.name, "clone");
    };

    PDFObject.prototype.toString = function () {
      throw new errors_1.MethodNotImplementedError(this.constructor.name, "toString");
    };

    PDFObject.prototype.sizeInBytes = function () {
      throw new errors_1.MethodNotImplementedError(this.constructor.name, "sizeInBytes");
    };

    PDFObject.prototype.copyBytesInto = function (_buffer, _offset) {
      throw new errors_1.MethodNotImplementedError(this.constructor.name, "copyBytesInto");
    };

    return PDFObject;
  }();

  exports.default = PDFObject; //# sourceMappingURL=PDFObject.js.map

  return exports;
}